module.exports = __webpack_public_path__ + "img/atlas.2289a981.svg";